import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import _ from 'lodash';
import moment from 'moment';
import AnnounceKit from 'announcekit-react';

import { constants } from '../helpers/constants';
import { getLastRelease, viewedLastReleaseDescription } from '../../action/ClientActions';
import CustomButton from '../CustomButton';

const UserDropdown = (props) => {
	const navigate = useNavigate();
	const { user, updateUser } = props;
	const roleName = constants.roleNames[user.roles[0]];
	let widgetRef = useRef(null);

	useEffect(() => {
		getLastRelease()
			.then(res => {
				const release = res.data.response

				if (_.isEmpty(user)) {
					return
				}

				if (release && moment.utc().isAfter(moment.utc(release.timestamp)) &&
					(!user.release_viewed || moment.utc(user.release_viewed).isBefore(moment.utc(release.timestamp)))
				) {
					widgetRef.open()
				}
			})
			.catch(err => {
				console.log(err)
			})
	}, []);

	const onReleaseViewed = () => {
		const timeReviewed = moment.utc();
		viewedLastReleaseDescription(timeReviewed.format('YYYYMMDDHHmm00'))
			.then(res => {
				updateUser({ ...user, release_viewed: timeReviewed.format('YYYY-MM-DD HH:mm:ss') })
			})
			.catch(err => {
				console.log(err)
			})
	}

	const handleClick = (url) => {
		props.closeDropdown();
		navigate(url);
	}

	return (
		<div>
			<div className="user-menu-item user-menu-title">
				{`${user.first_name} ${user.last_name}`}
				<div className="user-initials">
					<span>{user.first_name[0] + user.last_name[0]}</span>
				</div>
				<div className="user-menu-subtitle">
					<div>{roleName}</div>
					<strong>{user.email}</strong>
				</div>
			</div>

			<nav>
				<div className="user-menu-item">
					<CustomButton variant='link' onClick={() => handleClick('/account/settings')}>Settings</CustomButton>
				</div>
				<div className="user-menu-item">
					<AnnounceKit
						widget={"https://announcekit.co/widgets/v2/2Z9pGE"}
						onWidgetOpen={props.closeDropdown}
						onWidgetClose={onReleaseViewed}
						ref={elem => (widgetRef = elem)}
						user={{
							id: user.id,
							email: user.email
						}}
						data={{
							role: user.roles[0]
						}}
						widgetStyle={{
							height: '0.75em',
							top: '13px',
							position: 'absolute',
							left: '48px',
						}}
					>
						<CustomButton variant="link">What's New?</CustomButton>
					</AnnounceKit>
				</div>
				<div className='user-menu-item'>
					<CustomButton variant='link' onClick={() => handleClick('/support')}>Support</CustomButton>
				</div>
				<div className='user-menu-item logout'>
					<CustomButton variant='link' onClick={props.logOut}>Log Out</CustomButton>
				</div>
			</nav>

		</div>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
	}),
	dispatch => ({
		updateUser: (user) => {
			dispatch({ type: 'GET_USER_SUCCESS', payload: user });
		},
	}),
)(UserDropdown);
